module.exports = __webpack_public_path__ + "img/edu.2e0e31e0.png";